import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getOrderGeneratorsFieldsWorksPlanWorks: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
	},
	getOrderGeneratorsFieldsWorksPlanWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK,
	},
	getOrderGeneratorsFieldsWorksPlanWorksRelatedPlanWorks: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS_RELATED_PLAN_WORKS,
	},
	createOrderGeneratorsFieldsWorksPlanWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK,
	},
	createOrderGeneratorsFieldsWorksPlanWorkBulk: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK_BULK,
	},
	putOrderGeneratorsFieldsWorksPlanWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].PUT_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK,
	},
	patchOrderGeneratorsFieldsWorksPlanWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK,
	},
	deleteOrderGeneratorsFieldsWorksPlanWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK,
	},
	getOrderGeneratorsFieldsWorksPlanWorkPreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK_PREVIEW,
	},
	getOrderGeneratorsFieldsWorksPlanWorkPopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK_POPUP,
	},
}
